import type { Article } from '~/types'

export const useLoadRelatedArticles = (params: MaybeRef<Article.SearchRequest>) => {
  const fetchData = async (): Promise<Article.Model[]> => {
    const { fetchData } = useLoadArticles(params)
    const data = await fetchData()

    return unref(data?.data) || []
  }

  return {
    fetchData,
  }
}
